import React from "react";
import NativeSelect from "@mui/material/NativeSelect";
import InputLabel from "@mui/material/InputLabel";
import Button from "components/Shared/CustomButtons/Button";

const ReAssignInput = ({ recyclerList, reAssignHandler, cancelHandler }) => {
  const [selectedRecyclerId, setSelectedRecyclerId] = React.useState("");
  const handleChangeRecyclerId = (event) => {
    setSelectedRecyclerId(event.target.value);
  };
  return (
    <div>
      <div>
        <InputLabel
          shrink
          htmlFor="recylcer-select"
          style={{ textAlign: "start" }}
        >
          Select Recycler:
        </InputLabel>
        <NativeSelect
          // className={classes.filterInput}
          value={selectedRecyclerId}
          onChange={handleChangeRecyclerId}
          inputProps={{ id: "recylcer-select" }}
        >
          <option value="" disabled>
            Select Recycler
          </option>
          {recyclerList.map((recycler, index) => (
            <option
              key={recycler.id}
              value={recycler.id}
              style={{ width: "100%", overflowX: "auto" }}
            >
              {recycler.display_name} - {recycler.email}
            </option>
          ))}
        </NativeSelect>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-arround",
          alignItems: "center",
          width: "100%",
          margin: "20px auto",
        }}
      >
        <Button
          color="primary"
          size="lg"
          onClick={() => reAssignHandler(selectedRecyclerId)}
          style={{ flex: 1, margin: "0 10px" }}
        >
          Re-assign
        </Button>
        <Button
          color="secondary"
          size="lg"
          onClick={cancelHandler}
          style={{ flex: 1, margin: "0 10px" }}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default ReAssignInput;
